// Хаусын тэмдэг ба сурагчийн зураг — админы components/brand-тай ижил (лого: public/assets/images/houses, ягаан дугуй дэвсгэр)
import React, { useState } from "react";

const HOUSES = [
  ["Buhu", "Бөхөн", "buhu"], ["Hawt", "Хавтгай", "hawt"], ["Irve", "Ирвэс", "irve"], ["Khant", "Хандгай", "khant"],
  ["Maza", "Мазаалай", "maza"], ["Tsa", "Цаа буга", "tsa"], ["Tsen", "Цэн тогоруу", "tsen"], ["Yang", "Янгир", "yangir"],
];
const BY_KEY = Object.fromEntries(HOUSES.flatMap(([id, mn, file]) => {
  const h = { id, mn, file };
  return [[id.toLowerCase(), h], [mn.toLowerCase(), h], [mn.replace(/\s+/g, "").toLowerCase(), h]];
}));
export const houseOf = (key) => (key ? BY_KEY[String(key).trim().toLowerCase()] || BY_KEY[String(key).replace(/\s+/g, "").toLowerCase()] || null : null);
export const HOUSE_BG = "#5c1090";

// <HouseMark house="Tsen" size={28} /> — houseId эсвэл монгол нэрээр
export function HouseMark({ house, size = 28, className = "" }) {
  const h = houseOf(house);
  if (!h) return null;
  return (
    <span title={h.mn} className={`inline-flex items-center justify-center rounded-full shrink-0 ${className}`} style={{ width: size, height: size, background: HOUSE_BG }}>
      <img src={`/assets/images/houses/${h.file}.png`} alt={h.mn} style={{ width: size * 0.74, height: size * 0.74 }} className="object-contain" />
    </span>
  );
}

// Сурагчийн зураг (Drive thumbnail) — ачаалагдахгүй бол нэрийн эхний үсэг; house өгвөл баруун доод буланд хаусын тэмдэг
export function StudentPhoto({ src, name = "", size = 48, house, rounded = "full", className = "" }) {
  const [ok, setOk] = useState(true);
  const r = rounded === "full" ? "rounded-full" : "rounded-2xl";
  return (
    <span className={`relative inline-flex shrink-0 ${className}`} style={{ width: size, height: size }}>
      {src && ok
        ? <img src={src} alt={name} referrerPolicy="no-referrer" onError={() => setOk(false)} className={`w-full h-full object-cover ${r} bg-[#f3eeff]`} />
        : <span className={`w-full h-full ${r} bg-primary text-white font-bold flex items-center justify-center`} style={{ fontSize: size * 0.4 }}>{(name || "?").charAt(0)}</span>}
      {house && houseOf(house) && <HouseMark house={house} size={Math.max(18, size * 0.38)} className="absolute -right-1 -bottom-1 ring-2 ring-white" />}
    </span>
  );
}
